import { loginUrl } from '../api/endpoints'
import { isNative } from '../native/native'
import { nativeSignIn } from '../native/signIn'
import { useSession } from '../state/session'

const REDIRECT_KEY = 'boss-chat:login-redirect-at'
const LOOP_WINDOW_MS = 30_000

export function currentReturnTo(): string {
  const { pathname, search } = window.location
  const path = pathname.startsWith('/auth') ? '/' : pathname
  return `${path}${search}`
}

export function goToLogin(returnTo = currentReturnTo()): void {
  if (isNative()) {
    // In the app: the system browser signs in, and the app takes the session back (native app spec, section 5).
    void nativeSignIn().then((result) => {
      if (result === 'signed-in') window.location.assign(returnTo)
    })
    return
  }
  try {
    sessionStorage.setItem(REDIRECT_KEY, String(Date.now()))
  } catch {
    // storage unavailable
  }
  window.location.assign(loginUrl(returnTo))
}

function redirectedRecently(): boolean {
  try {
    const at = Number(sessionStorage.getItem(REDIRECT_KEY) ?? 0)
    return Date.now() - at < LOOP_WINDOW_MS
  } catch {
    return false
  }
}

/**
 * Called by the API client on any 401.
 * - Offline: stay on cached data.
 * - "gate" (GET /api/me), an unverified cached session, or a redirect that just happened: show
 *   the sign-in screen.
 * - Otherwise the session expired mid-use: send the user to the IdP.
 */
export function handleUnauthorized(mode: 'redirect' | 'gate'): void {
  if (!navigator.onLine) return
  // Until GET /api/me has confirmed the session, a 401 means "not signed in": show the sign-in screen. In the app, always: the
  // system browser opening by itself would be a surprise.
  if (isNative() || mode === 'gate' || !useSession.getState().verified || redirectedRecently()) {
    useSession.getState().setUnauthenticated()
    return
  }
  goToLogin()
}
